"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalComponent = void 0;
require("./modal.scss");
var Component_1 = require("../Component");
var util_1 = require("../util");
var ModalComponent = /** @class */ (function (_super) {
    __extends(ModalComponent, _super);
    function ModalComponent(options) {
        var _this = _super.call(this, util_1.htmlDiv()) || this;
        _this.options = options;
        _this.keyListener = function (ev) {
            if (ev.key === 'Escape' || ev.key == 'Esc')
                _this.close();
        };
        return _this;
    }
    ModalComponent.prototype.onInit = function () {
        this.$element.addClass('wk-modal');
        if (this.options.title) {
            this.$head = util_1.$div('wk-modal-head').append(this.createCloseButton(), util_1.$element('h3', 'title').setText(this.options.title));
            this.$element.append(this.$head);
        }
        this.$body = util_1.$div('wk-modal-body');
        this.$element.addClass('wk-modal').append(this.$body);
        if (this.options.fullsize)
            this.$element.addClass('full-size');
        switch (this.options.animation) {
            case 'move-up':
                this.$element.addClass('animation-move-up');
                break;
            case 'fade-in':
                this.$element.addClass('animation-fade-in');
                break;
        }
    };
    ModalComponent.prototype.createCloseButton = function () {
        var _this = this;
        var $shape;
        if (this.options.fullsize) {
            $shape = util_1.$svg('svg', 'fa', {
                'data-icon': 'chevron-left',
                viewBox: '0 0 320 512',
            }).append(util_1.$svg('path', {
                fill: 'currentColor',
                d: 'M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z',
            }));
        }
        else {
            $shape = util_1.$svg('svg', 'fa', {
                'data-icon': 'times',
                viewBox: '0 0 352 512',
            }).append(util_1.$svg('path', {
                fill: 'currentColor',
                d: 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z',
            }));
        }
        return util_1.$element('a', 'btn-close')
            .append($shape)
            .on('click', function () { return _this.close(); });
    };
    ModalComponent.prototype.onDestroy = function () {
        var _a;
        var container = document.querySelector('.wk-modal-container');
        if (container) {
            (_a = container.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(container);
        }
    };
    ModalComponent.prototype.setContent = function (element) {
        this.$body.empty().append(element);
    };
    ModalComponent.prototype.getContainer = function () {
        var container = document.querySelector('.wk-modal-container');
        if (!container) {
            container = util_1.htmlDiv('wk-modal-container');
            document.body.appendChild(container);
        }
        return util_1.$helper(container);
    };
    ModalComponent.prototype.show = function () {
        var _this = this;
        if (!this.isInitialize())
            this.init();
        var $container = this.getContainer().empty();
        if (!this.options.fullsize) {
            var backdrop = util_1.$div('wk-modal-backdrop');
            if (this.options.backdrop === false) {
                backdrop.addClass('transparent');
            }
            if (this.options.backdrop !== 'static') {
                backdrop.on('click', function () { return _this.close(); });
            }
            backdrop.on('mousewheel', function (ev) { return ev.preventDefault(); });
            $container.append(backdrop);
        }
        $container.append(this.$element);
        if (!this.options.fullsize && this.options.position === 'bottom') {
            $container.addClass('stick-to-bottom');
        }
        else {
            $container.removeClass('stick-to-bottom');
        }
        if (this.options.keyboard || this.options.keyboard === undefined) {
            document.addEventListener('keydown', this.keyListener);
        }
        if (this.options.fullsize) {
            this.docBodyOrgOverflowY = document.body.style.overflowY;
            document.body.style.overflowY = 'hidden';
        }
        setTimeout(function () {
            var backdrop = _this.getContainer().findFirst('.wk-modal-backdrop:not(.transparent)');
            if (backdrop)
                backdrop.classList.add('show');
            _this.$element.addClass('show');
            _this.onShown();
        }, 10);
    };
    ModalComponent.prototype.onShown = function () { };
    ModalComponent.prototype.close = function () {
        var _this = this;
        if (this.options.animation) {
            var backdrop = this.getContainer().findFirst('.wk-modal-backdrop.show');
            if (backdrop)
                backdrop.classList.remove('show');
            this.$element.removeClass('show');
            setTimeout(function () {
                _this.onClose();
                _this.destroy();
            }, 300);
        }
        else {
            this.onClose();
            this.destroy();
        }
    };
    ModalComponent.prototype.onClose = function () {
        if (this.options.fullsize) {
            document.body.style.overflowY = this.docBodyOrgOverflowY;
        }
    };
    ModalComponent.prototype.onRemoved = function () {
        _super.prototype.onRemoved.call(this);
        document.removeEventListener('keydown', this.keyListener);
    };
    return ModalComponent;
}(Component_1.Component));
exports.ModalComponent = ModalComponent;
